import React, { useEffect, useRef, useContext, useCallback } from 'react';
import DataContext from './DataContext';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { config } from '../../utils/config';

export default function ImageUpload() {

    let { lid } = useParams()

    const cloudinaryRef = useRef();
    const widgetRef = useRef();
    const formData = useContext(DataContext)

    const handleOnDragEnd = useCallback((result) => {
        if (!result.destination) {
            return
        }
        const clone = formData.getMediaData().slice();
        const [reorderItems] = clone.splice(result.source.index, 1);
        clone.splice(result.destination.index, 0, reorderItems);
        formData.updateMediaData(clone)
    }, [formData])

    const deleteImage = useCallback(async (id) => {

        // Delete the image from Cloudinary
        const response = await axios.post(`${config.apiBaseUrl}/cloudinary/delete-selection-image`, { publicId: id })

        // console.log(response)

        if (response.data === 'deleted') {
            // Remove the image ID from the component's state
            // setImageIds(prevIds => prevIds.filter(prevId => prevId !== id));
            const clone = formData.getMediaData().slice()
            const indexToDelete = clone.findIndex((o) => { return o.cloud_id === id })
            const modifiedClone = [...clone.slice(0, indexToDelete), ...clone.slice(indexToDelete + 1)]
            formData.updateMediaData(modifiedClone)
            console.log("image deleted")
            widgetRef.current.close({ quiet: true })
        }

    }, [formData])

    useEffect(() => {

        if (lid && lid !== "add") {

            const getData = async () => {

                const response = await axios.get(`${config.apiBaseUrl}/editlisting/${lid}`)
                const d = response.data
                // console.log("data", d.media)
                formData.updateMediaData(d.media)
            }

            getData()

        } else {
            formData.updateMediaData([])
        }

        cloudinaryRef.current = window.cloudinary;
        widgetRef.current =

            cloudinaryRef.current.createUploadWidget({
                cloudName: 'dxnkwi2rt',
                uploadPreset: 'ml_default',
                multiple: true,
                maxFiles: 8,
                // cropping: true,
                resourceType: "auto",
                croppingAspectRatio: 1.5,
                maxImageWidth: 3000,
                maxImageHeight: 2000,
                maxImageFileSize: 5000000,


            }, function (error, result) {
                console.log(result)
                if (result.event === 'success') {
                    const media_url = result.info.secure_url
                    const cloud_id = result.info.public_id
                    const media_type = result.info.resource_type
                    formData.updateMediaData((clone) => [...clone, { cloud_id, media_url, media_type }])
                    widgetRef.current.hide();
                }
            })

    }, [lid])

    return (
        <>
            <div>
                <button className='btn btn-success mb-3' onClick={() => { widgetRef.current.open() }}>Upload Media</button>
            </div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <div className="container">
                    <div className="row">
                        <Droppable droppableId="showimage">
                            {(provided) => (
                                <div className="showimage" style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {formData.getMediaData().map((r, index) => {
                                        return (
                                            <Draggable key={r.cloud_id} draggableId={r.cloud_id} index={index}>
                                                {(provided) => (
                                                    <div
                                                        className="col mx-auto d-block"
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <div className="card border-light" style={{ width: "12rem" }}>
                                                            <div style={{
                                                                overflow: 'hidden',
                                                                height: '100px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}>
                                                                <img src={r.media_url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} className="card-img-top" alt="..." />
                                                            </div>
                                                            <div className="card-body">
                                                                <button className="btn btn-primary btn-sm" onClick={() => { deleteImage(r.cloud_id) }}>Delete</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                </div>
            </DragDropContext>
        </>
    )
}

